<template>
  <div class="container_box" id="video_box">
    <div class="van_swipe">
      <van-swipe
        :show-indicators="false"
        @change="onChange"
        vertical
        :loop="false"
      >
        <van-swipe-item
          v-for="(item, index) in videoList"
          :key="index"
          class="product_swiper"
        >
          <div class="video_container">
            <video
              class="video_box"
              width="100%"
              height="100%"
              webkit-playsinline="true"
              x5-playsinline=""
              x5-video-player-type="h5"
              x5-video-player-fullscreen=""
              playsinline
              preload="auto"
              :poster="item.CoverUrl"
              :src="item.MediaUrl"
              :playOrPause="playOrPause"
              x-webkit-airplay="allow"
              x5-video-orientation="portrait"
              @click="pauseVideo"
              @ended="onPlayerEnded($event)"
              loop="loop"
            ></video>
            <!-- 封面 -->
            <img
              v-show="isVideoShow"
              class="play"
              @click="playvideo"
              :src="item.CoverUrl"
            />
            <!-- 播放暂停按钮 -->
            <img
              v-show="iconPlayShow"
              class="icon_play"
              @click="playvideo"
              src="../../../static/images/icon/play.png"
            />
          </div>
          <!-- 点赞、评论、转发功能 -->
          <div class="tools_right">
            <div class="tools_r_li" @click="changeComment">
              <div class="iconfont icon-pinglun-fill o_img"></div>
              <div class="tools_r_num" v-if="item.Comment">
                {{ item.Comment }}
              </div>
            </div>
            <div class="tools_r_li" @click="onLike(item.PostId, index)">
              <div
                class="iconfont icon-favorites-fill o_img"
                v-if="item.IsLike"
                style="color: #d62f2f"
              ></div>
              <div
                class="iconfont icon-favorites-fill o_img"
                v-else
                style="color: #ffffff"
              ></div>
              <div class="tools_r_num" v-if="item.LikeCount">
                {{ item.LikeCount }}
              </div>
            </div>
            <div
              class="tools_r_li"
              @click.stop="
                shareHandle(item.Headline, item.Content, item.CoverUrl)
              "
            >
              <div class="iconfont icon-zhuanfa-fill o_img"></div>
            </div>
          </div>
          <!-- 底部作品描述 -->
          <div class="production_box">
            <div
              class="product"
              v-if="item.PostGoodModel"
              @click="toProductDetail(item.PostGoodModel.GoodsID)"
            >
              <img class="proImg" :src="item.PostGoodModel.Thumbnail" />
              <div class="overFlowOne">同款产品</div>
            </div>
            <div class="company">
              <img class="companyImg" :src="item.Photo" />
              <div class="companyName">
                {{ item.Headline }}
              </div>
              <div
                class="followBtn"
                :class="item.IsFollow ? 'active' : ''"
                @click="followChange(item.MemberId, index)"
              >
                {{ item.IsFollow ? "已关注" : "关注" }}
              </div>
            </div>
            <div class="content overFlowOne">
              {{ item.Content }}
            </div>
            <div class="label-box">
              <div class="circle overFlowOne" v-if="item.Circle">
                <div class="iconfont icon-quanzi"></div>
                {{ item.Circle }}
              </div>
              <div v-for="(tItem, tIndex) in item.TopicList" :key="tIndex">
                <div
                  class="topic overFlowOne"
                  :style="
                    tIndex == 1
                      ? 'color:#7896d3;'
                      : tIndex == 2
                      ? 'color:#d4a345;'
                      : ''
                  "
                  @click.stop="toTopicDetail(tItem.TopicId)"
                >
                  #{{ tItem.TopicName }}#
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>

      <!--留言弹窗-->
      <van-popup
        v-model="commentPop"
        closeable
        :overlay="true"
        class="comment_container"
        position="bottom"
      >
        <div class="comment-box">
          <div class="cmtTop">{{ total }}条评论</div>
          <input
            type="text"
            class="input"
            :focus="focus"
            v-model="commentValue"
            confirm-type="send"
            :placeholder="placeholder"
            @keyup.enter="commentConfirm"
          />
          <div class="cmtScroll">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text=""
              :error.sync="error"
              error-text="请求失败，点击重新加载"
              @load="getCommentHandle"
            >
              <div v-for="(item, index) in commentList" :key="index">
                <div class="c_item">
                  <img :src="item.Photo" class="avatarImg" />
                  <div class="ci_right">
                    <div class="cir_top">
                      <div>{{ item.MemberName }}</div>
                      <div
                        class="like"
                        @click.stop="onLikeChange(item.RecordId, index)"
                      >
                        <van-icon
                          :name="item.IsLike ? 'like' : 'like-o'"
                          :color="item.IsLike ? '#d62f2f' : '#999'"
                          size="16px"
                          style="margin-right: 4px"
                        />
                        <div v-if="item.LikeCount">{{ item.LikeCount }}</div>
                      </div>
                    </div>
                    <div
                      class="content"
                      @click.stop="toReply(item.RecordId, index)"
                    >
                      {{ item.Content }}
                    </div>
                    <div class="time">
                      {{ item.CreateTimeDesc }}
                      <div
                        @click.stop="onReply(item.RecordId, index)"
                        v-if="item.CommentCount > 0"
                      >
                        {{ item.CommentCount }}回复
                      </div>
                    </div>

                    <!-- 回复 -->
                    <div class="replyScroll" v-if="item.IsClose">
                      <div v-for="(rItem, rIndex) in replyList" :key="rIndex">
                        <div class="c_item">
                          <img :src="rItem.Photo" class="avatarImg" />
                          <div class="ci_right">
                            <div class="cir_top">
                              <div>{{ rItem.MemberName }}</div>
                              <div
                                class="like"
                                @click.stop="
                                  onReplyChange(rItem.RecordId, rIndex)
                                "
                              >
                                <van-icon
                                  :name="rItem.IsLike ? 'like' : 'like-o'"
                                  :color="rItem.IsLike ? '#d62f2f' : '#999'"
                                  size="16px"
                                  style="margin-right: 4px"
                                />
                                <div v-if="rItem.LikeCount">
                                  {{ rItem.LikeCount }}
                                </div>
                              </div>
                            </div>
                            <div class="content">{{ rItem.Content }}</div>
                            <div class="time">{{ rItem.CreateTimeDesc }}</div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="moreReply"
                        v-if="replyList.length < replyTotal"
                        @click.stop="replyMoreOpen()"
                      >
                        —— 展开更多回复
                        <div class="iconfont icon-xiala"></div>
                      </div>
                      <div
                        class="moreReply"
                        v-else
                        @click.stop="replyMoreClose(index)"
                      >
                        —— 收起
                        <div class="iconfont icon-shangla"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </div>
        </div>
      </van-popup>

      <!--分享-->
      <div class="shareLayer" v-show="showLayer" @click="showLayer = false">
        <img src="../../../static/images/index/layer.png" />
      </div>
      <!--遮罩层-->
      <van-overlay v-show="showLayer" @click="showLayer = false"></van-overlay>
    </div>
  </div>
</template>
<script>
import { getShareData } from "@/utils/share";
import { getTempId, videoInfo, postVodRead } from "@/api/video";
import {
  createPostLike,
  cancelPostLike,
  followMember,
  unFollowMember,
  postComment,
  postCommentLike,
  cancelCommentLike,
  createPostComment,
} from "@/api/index";
import { Icon, List, Overlay, Popup, Swipe, SwipeItem, Toast } from "vant";
export default {
  name: "videoDetails",
  components: {
    Toast,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-popup": Popup,
    "van-icon": Icon,
    "van-list": List,
    "van-overlay": Overlay,
  },
  data() {
    let u = navigator.userAgent;
    return {
      showLayer: false,
      current: 0, //视频index
      videoList: [], //视频列表
      isVideoShow: true, //视频封面
      playOrPause: true,
      video: null,
      iconPlayShow: true, //播放按钮
      isAndroid: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, // android终端
      isiOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端

      commentPop: false,
      focus: false,
      commentValue: "",

      recordIndex: 0, //记录点击回复时的下标值
      loading: false,
      finished: false,
      error: false,
      pageIndex: 1,
      total: 0,
      commentList: [], //评论列表

      replyId: null, //回复id-(用于评论or评论的回复)
      replyPageIndex: 1,
      replyTotal: 0,
      replyList: [], //回复列表
      placeholder: "说点什么吧…",

      tempId: "",
    };
  },

  methods: {
    //分享好友
    shareHandle(title, desc, img) {
      this.showLayer = true;
      //调用转发
      getShareData(
        window.location.href,
        title + "发了视频动态，快来看看呀!",
        this.Common.ToText(desc).substr(0, 50)
          ? this.Common.ToText(desc).substr(0, 50)
          : "",
        img
      );
    },

    //获取视频列表
    getVideoList() {
      var that = this;
      var data = {
        PostId: that.$route.query.vid ? that.$route.query.vid : 0,
        TempId: this.tempId,
        Size: 12,
      };
      videoInfo(data).then((res) => {
        that.videoList = res.Data.List;
      });
    },

    //滑动改变播放的视频
    onChange(index) {
      let video = document.querySelectorAll("video")[this.current];
      video.pause();
      this.playOrPause = false;
      this.current = index;
      var data = {
        PostId: 0,
        TempId: this.tempId,
      };
      postVodRead(data).then((res) => {
        console.log(res.Data);
      });
      //非ios切换直接自动播放下一个
      if (this.isiOS) {
        this.isVideoShow = false;
        this.pauseVideo();
      } else {
        //ios官方禁止video自动播放，未找到合适的方法，如果您发现了，麻烦告诉我一下谢谢啦
        this.isVideoShow = true;
        this.iconPlayShow = true;
      }
    },

    //开始播放
    playvideo() {
      let video = document.querySelectorAll("video")[this.current];
      console.log(video.play());
      console.log("playvideo：" + this.current);
      this.isVideoShow = false;
      this.iconPlayShow = false;
      video.play();
      window.onresize = function () {
        video.style.width = window.innerWidth + "px";
        video.style.height = window.innerHeight + "px";
      };
    },

    //暂停or播放
    pauseVideo() {
      let video = document.querySelectorAll("video")[this.current];
      console.log("pauseVideo" + this.current);
      if (this.playOrPause) {
        video.pause();
        this.iconPlayShow = true;
      } else {
        video.play();
        this.iconPlayShow = false;
      }
      this.playOrPause = !this.playOrPause;
    },

    //视频结束
    onPlayerEnded(player) {
      this.isVideoShow = true;
      this.current += this.current;
    },

    //点赞切换
    onLike(id, index) {
      var list = this.videoList;
      if (list[index].IsLike) {
        cancelPostLike({
          PostId: id,
        }).then((res) => {
          list[index].IsLike = false;
          list[index].LikeCount--;
        });
      } else {
        createPostLike({
          PostId: id,
        }).then((res) => {
          list[index].IsLike = true;
          list[index].LikeCount++;
        });
      }
      this.videoList = list;
    },

    // 头条号操作
    followChange(id, index) {
      var list = this.videoList;
      if (list[index].IsFollow) {
        unFollowMember({
          MemberId: id,
        }).then((res) => {
          list[index].IsFollow = false;
          Toast("取消关注");
        });
      } else {
        followMember({
          MemberId: id,
        }).then((res) => {
          list[index].IsFollow = true;
          Toast("关注成功");
        });
      }
      this.videoList = list;
    },

    //弹出评论窗口
    changeComment() {
      this.commentPop = true;
      this.placeholder = "说点什么吧…";
      this.replyTotal = 0;
      this.replyPageIndex = 1;
      this.replyList = [];
    },

    //获取评论列表
    getCommentHandle() {
      var that = this;
      var data = {
        PostId: this.$route.query.vid,
        Page: {
          PageSize: 10,
          PageIndex: this.pageIndex,
        },
        CommentRecordId: 0,
      };
      postComment(data).then((res) => {
        if (that.pageIndex == 1) {
          that.commentList = [...res.Data.List];
        } else {
          that.commentList = [...that.commentList, ...res.Data.List];
        }
        that.total = res.Data.Total;
        that.pageIndex += 1;
        // 加载状态结束
        that.loading = false;
        // 数据全部加载完成
        if (that.commentList.length >= that.total) {
          that.finished = true;
        }
      });
    },

    //评论点赞
    onLikeChange(rid, index) {
      var list = this.commentList;
      if (list[index].IsLike) {
        cancelCommentLike({
          RecordId: rid,
          VodId: this.$route.query.vid,
        }).then((res) => {
          list[index].IsLike = false;
          list[index].LikeCount--;
        });
      } else {
        postCommentLike({
          RecordId: rid,
          PostId: this.$route.query.vid,
        }).then((res) => {
          list[index].IsLike = true;
          list[index].LikeCount++;
        });
      }
      this.commentList = list;
    },

    //回复评论点赞
    onReplyChange(rid, index) {
      var list = this.replyList;
      if (list[index].IsLike) {
        cancelCommentLike({
          RecordId: rid,
          VodId: this.$route.query.vid,
        }).then((res) => {
          list[index].IsLike = false;
          list[index].LikeCount--;
        });
      } else {
        postCommentLike({
          RecordId: rid,
          PostId: this.$route.query.vid,
        }).then((res) => {
          list[index].IsLike = true;
          list[index].LikeCount++;
        });
      }
      this.replyList = list;
    },

    // 评论数量点击
    onReply(rid, index) {
      var that = this;
      var list = that.commentList;
      list.forEach(function (item, idx) {
        if (item.RecordId == rid) {
          item.IsClose = true;
        } else {
          item.IsClose = false;
        }
      });

      that.commentList = list;
      that.replyId = rid;
      that.recordIndex = index;
      that.replyPageIndex = 1;
      that.replyList = [];
      that.getReplyHandle();
    },

    //获取回复列表
    getReplyHandle() {
      var that = this;
      var data = {
        PostId: this.$route.query.vid,
        Page: {
          PageSize: 3,
          PageIndex: this.replyPageIndex,
        },
        CommentRecordId: this.replyId,
      };
      postComment(data).then((res) => {
        if (that.replyPageIndex == 1) {
          that.replyList = [...res.Data.List];
        } else {
          that.replyList = [...that.replyList, ...res.Data.List];
        }
        that.replyTotal = res.Data.Total;
      });
    },

    //回复更多点击
    replyMoreOpen() {
      var that = this;
      if (that.replyList.length >= that.replyTotal) {
        console.log("数据加载完毕");
      } else {
        if (that.replyList.length > 0) {
          this.replyPageIndex = that.replyPageIndex += 1;
          that.getReplyHandle();
        } else {
          console.log("底部了");
        }
      }
    },

    //回复收起
    replyMoreClose(index) {
      var list = this.commentList;
      list[index].IsClose = false;
      this.commentList = list;
      this.replyId = null;
      this.replyPageIndex = 1;
      this.replyList = [];
    },

    //评论回复点击
    toReply(rid, index) {
      this.placeholder = "@" + this.commentList[index].MemberName;
      this.replyId = rid;
      this.focus = true;
    },

    //点击确认
    commentConfirm() {
      var that = this;
      var data = {
        Content: this.commentValue,
        PostId: this.$route.query.vid,
        CommentRecordId: this.replyId ? this.replyId : 0,
      };
      createPostComment(data).then((res) => {
        setTimeout(() => {
          Toast("发表成功");
          setTimeout(() => {
            if (that.replyId) {
              this.commentValue = "";
              this.replyPageIndex = 1;
              this.replyList = [];
              that.commentList[that.recordIndex].CommentCount++;
              that.getReplyHandle();
            } else {
              this.commentValue = "";
              this.pageIndex = 1;
              this.commentList = [];
              that.getCommentHandle();
            }
            that.commentPop = false;
            that.getVideoList();
          }, 1000);
        }, 0);
      });
    },

    //跳转话题详情
    toTopicDetail(hid) {
      this.$router.push({ path: "/hotTopicDetails", query: { hid: hid } });
    },

    //跳转产品详情
    toProductDetail(id) {
      this.$router.push({ path: "/productDetail", query: { id: id } });
    },
  },

  mounted() {
    this.tempId = getTempId();
    this.getVideoList();
    let video = document.querySelectorAll("video")[0];
    //必须在微信Weixin JSAPI的WeixinJSBridgeReady才能生效
    // document.addEventListener(
    //   "WeixinJSBridgeReady",
    //   function () {
    //     video.play();
    //   },
    //   false
    // );
    if (typeof WeixinJSBridge !== "undefined") {
      WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
        // 利用该方法进行自动播放
        video.play();
      });
    }
  },
};
</script>
<style scoped src="../../../static/css/videoDetails.css"></style>
